// extracted by mini-css-extract-plugin
export default {"question__container":"question_question__container__9GtGM","question__title":"question_question__title__zRXV8"};